<template>
  <div :class="['definition-wrapper', 'multi-choice', definition.id, {'error_validate': mandatoryValidation}, {'ok_validate': !mandatoryValidation && multiChoiceValue && multiChoiceValue.length > 0}]">
    <definition-choice-api v-if="editable && isApiDomain"
      :definition="definition" :type="type" :authorization="authorization" :definitionContentId="definitionContentId" :language="language"
      :isNoSearch="isNoSearch" :content="content" :parentChoiceKeys="parentChoiceKeys" :object="object"
      @apiElementAdded="apiElementAdded" @apiCallResponse="apiCallResponse"
    />
    <div v-if="editable && !gallery && !checkbox && !doublelist && !isMultiLanguage()" class="multiselect-wrapper">
      <span class="counter">{{object.domainValue.length}}/{{definition.validation.domain.length}}</span>
      <multiselect
        size="5"
        v-bind:id="'arrow_' + definition.id"
        v-if="editable"
        :options="getDomain()"
        track-by="key"
        label="value"
        :placeholder="getPlaceholder()"
        :selectLabel="getLang('enterForSelect')"
        :deselectLabel="getLang('enterForDelete')"
        v-model="multiChoiceValue"
        :multiple="multiple"
        :close-on-select="false"
        :preserveSearch="true"
        :searchable="true"
        :max="definition.validation.mandatory.max"
        @open="openValue"
        @remove="removeValue"
        @close="selectValue"
      >
        <template #singleLabel="{ option }">
          {{ option.value }}
        </template>
        <template v-if="isExpanded()" #option="{ option }">
          <i :class="['sherpa-icon','icon-' + option.key]"></i>
          <span> {{ option.value }} </span>
        </template>
        <template #maxElements>
          {{ getLang('maxOptions', ['numOptions'], [definition.validation.mandatory.max]) }}
        </template>
        <template #noResult>
          {{ getLang('noResults') }}
        </template>
        <template #caret><span v-bind:class="[{'active':isOpen}, {'expanded':isExpanded()}]" class="arrow"><i class="fa fa-angle-down fa-2x"></i></span></template>
      </multiselect>
    </div>
    <div v-else-if="editable && checkbox" class="checkbox-wrapper">
      <p-check v-for="(domain) in getDomain()" :key="domain.key"
        :name="definition.id"
        :class="[getPrettyClasses(checkbox), 'p-smooth', 'p-bigger', {'p-locked': !editable}]"
        color="primary"
        :value="domain.key"
        v-model="checkboxValues"
        @click.native="checkboxClick(domain.key)"
      >
        {{ domain.value }}
      </p-check>
    </div>
    <div v-else-if="editable && (doublelist || isMultiLanguage())" class="doublelist-wrapper">
      <api-list v-if="isApiDomain"
        :label="definition.label"
        :items="getDomain()"
        itemIdKey="key"
        v-model="multiChoiceValue"
        :language="language"
        :showMultilanguage="isMultiLanguage() && showMultilanguage"
        :definition="definition"
        :object="object"
        :languageSelected="languageSelected"
        :apiparams="apiparams"
        :isApiDomainEditable="isApiDomain"
        @input="doubleListInput"
        @newLanguageSelected="newLanguageSelected"
      >
        <template #item="props">
          {{ props.item.value }}
        </template>
      </api-list>
      <double-list v-else
        :domain="multiDomain"
        :getLang="getLang"
        :selected="true"
        @newSelectedList="newSelectedList"
      />
    </div>
    <definition-read-only v-else :definitionId="definitionId" :definition="definition" :object="object" :visualDefinition="visualDefinition" />
    <definition-task v-if="definition.task && definition.task.length > 0 && editable"
      :definition="definition" :object="object" :definitionObject="definitionObject" :definitionContentId="definitionContentId" :repeatableGroupCode="repeatableGroupCode" :language="language" :authorization="authorization" :type="type" :visuals="visuals" :apiparams="apiparams" :callTask="callTask"
      @refreshDefinition="taskValueChanged" @refreshDefinitionContent="refreshDefinitionContent" @taskLink="taskLink"
    />
  </div>
</template>

<script>
import DefinitionReadOnly from './readOnly'
import Multiselect from '@/components/shared/Multiselect.vue' // 'vue-multiselect ^2.1.6' component with TMD modifications
import doubleList from './doubleList'
import apiList from './apiList'
import DefinitionTask from './task'
import DefinitionChoiceApi from './choiceApi'
import moment from 'moment'
import transport from 'vue-definition-utils/src/utils/transport'
import language from '../language'
import SpinnerLoading from '@/components/shared/SpinnerLoading.vue'
import PrettyCheck from '@/components/shared/PrettyCheck.vue'

export default {
  name: 'definition-multi-choice',
  props: [
    'definition',
    'object',
    'definitionObject',
    'editable',
    'mandatoryValidation',
    'languageSelected',
    'definitionId',
    'definitionContentId',
    'repeatableGroupCode',
    'showMultilanguage',
    'gallery',
    'checkbox',
    'doublelist',
    'requestObjectForAdd',
    'requestObjectForAddModified',
    'language',
    'visualDefinition',
    'authorization',
    'type',
    'visuals',
    'apiparams',
    'placeholder',
    'callTask',
    'isApiDomain',
    'isNoSearch',
    'showDesc',
    'content',
    'parentChoiceKeys'
  ],
  components: {
    DefinitionReadOnly,
    DefinitionTask,
    Multiselect,
    doubleList,
    apiList,
    SpinnerLoading,
    PrettyCheck,
    DefinitionChoiceApi
  },
  data () {
    return {
      multiChoiceValue: null,
      closeOnSelect: false,
      multiple: true,
      isOpen: false,
      checkboxValues: [],
      clickCheckbox: false
    }
  },
  methods: {
    selectValue (selectedValue) {
      this.isOpen = false
      var self = this
      setTimeout(function () {
        if (!self.isOpen) {
          self.refreshValues()
        }
      }, 300)
    },
    refreshValues () {
      var value = []
      if (this.multiChoiceValue) {
        value = this.multiChoiceValue
      }
      this.object.domainValue = value
      this.$emit('validateMandatory', moment().valueOf(), this.object)
    },
    openValue () {
      this.isOpen = true
    },
    // 1.2. Launch validate mandatory event on remove one option
    removeValue (removedOption) {
      if (!this.isOpen) {
        var value = []
        for (var i = 0; i < this.multiChoiceValue.length; i++) {
          if (this.multiChoiceValue[i].key !== removedOption.key) {
            value.push(this.multiChoiceValue[i])
          }
        }
        this.object.domainValue = value
        this.$emit('validateMandatory', moment().valueOf(), this.object)
      }
    },
    isExpanded () {
      return this.isClass('expanded')
    },
    isIcons () {
      return this.isClass('icons')
    },
    isClass (classStr) {
      var visualDef = this.visualDefinition.getDefinitionFields(this.definition)
      return visualDef && visualDef.class && visualDef.class.search(classStr) >= 0
    },
    getLang (key, params, values) {
      return language(this.language, key, params, values)
    },
    taskValueChanged (object) {
      this.$emit('refreshDefinition', object)
    },
    checkboxClick (key) {
      this.multiChoiceValue = []
      var found = false

      this.clickCheckbox = true

      for (var i = 0; i < this.checkboxValues.length; i++) {
        if (key === this.checkboxValues[i]) {
          found = true
        } else {
          this.multiChoiceValue.push(transport.methods.getDomainValue(this.definition.validation.domain, this.checkboxValues[i]))
        }
      }
      if (!found) {
        this.multiChoiceValue.push(transport.methods.getDomainValue(this.definition.validation.domain, key))
      }
      this.refreshValues()
    },
    getPrettyClasses (classesStr) {
      var result = ''
      var classes = classesStr.split(' ')
      if (classes) {
        for (var i = 0; i < classes.length; i++) {
          if (classes[i].substr(0, 2) === 'p-') {
            result += ' ' + classes[i]
          }
        }
      }
      return result
    },
    getPlaceholder () {
      var result = this.placeholder
      if (!result) {
        result = this.getLang('select')
      }
      return result
    },
    doubleListInput (values) {
      this.refreshValues()
    },
    isMultiLanguage () {
      return transport.methods.isMultiLanguage(this.definition)
    },
    newLanguageSelected (language) {
      this.$emit('newLanguageSelected', language)
    },
    refreshDefinitionContent () {
      this.$emit('refreshDefinitionContent')
    },
    getDomain () {
      var result = []
      if (this.definition.validation.domain) {
        for (var i = 0; i < this.definition.validation.domain.length; i++) {
          if (this.definition.validation.domain[i].visible) {
            result.push(this.definition.validation.domain[i])
          }
        }
      }
      return result
    },
    taskLink (obj) {
      this.$emit('taskLink', obj)
    },
    apiElementAdded (element) {
      this.multiChoiceValue.push(element)
      this.refreshValues()
    },
    apiCallResponse () {
      if (this.multiChoiceValue) {
        this.multiChoiceValue = this.multiChoiceValue.filter(multiChoiceItem =>
          this.definition.validation.domain.some(domainItem => domainItem.key === multiChoiceItem.key)
        )
        this.refreshValues()
      }
    },
    newSelectedList (value) {
      this.multiChoiceValue = value
      this.refreshValues()
    }
  },
  computed: {
    apiSearchInputName () {
      return 'searcher-api-' + this.definition.id
    },
    multiDomain () {
      const selected = this.multiChoiceValue
      const all = this.getDomain() || []

      const selectedKeys = new Set(selected.map(item => item.key))

      const notSelected = all.filter(item => !selectedKeys.has(item.key))

      return {
        selected,
        notSelected
      }
    }
  },
  beforeMount () {
    if (this.object && this.definition.validation) {
      this.multiChoiceValue = transport.methods.getCheckedDomainValues(this.object.domainValue, this.definition.validation.domain)
      if (!this.multiChoiceValue) {
        this.multiChoiceValue = []
      }
      this.object.domainValue = this.multiChoiceValue
      if (this.multiChoiceValue) {
        for (var i = 0; i < this.multiChoiceValue.length; i++) {
          this.checkboxValues.push(this.multiChoiceValue[i].key)
        }
      }
    }
  },
  watch: {
    mandatoryValidation (value) {
      // 2. if mandatory validation past...
      if (value && (!value.validateKey || value.validateKey.trim() === '')) {
        // ... launch refresh definition event
        this.$emit('refreshDefinition', this.object)
      }
    },
    object: {
      handler: function (value) {
        if (value && value.domainValue) {
          this.multiChoiceValue = value.domainValue
        }
        if (!this.clickCheckbox) {
          if (this.multiChoiceValue) {
            this.checkboxValues = []
            for (var i = 0; i < this.multiChoiceValue.length; i++) {
              this.checkboxValues.push(this.multiChoiceValue[i].key)
            }
          }
        } else {
          this.clickCheckbox = false
        }
      },
      deep: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
label {
  margin-bottom: 5px;
}
.counter {
  position: absolute;
  top: -13px;
  font-size: 12px;
  font-family: "Source Sans Pro", sans-serif;
  color: #666;
  font-weight: 600;
  display: none;
}
</style>

<style lang="scss">
.checkbox-wrapper {
  float: left;
}
.pretty {
  margin-bottom: 10px;
}
.arrow.expanded {
  display: none;
}
.arrow.active {
  -ms-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}
.expanded .multi-choice .multiselect__select {
  display: none;
}
.expanded .multi-choice .multiselect__tags {
  display: none;
}
.expanded .multi-choice .multiselect__content-wrapper {
  max-height: none !important;
  display: block !important;
  position: static !important;
  border-left: 1px solid #efefef;
  border-top: 1px solid #efefef;
  border-right: 1px solid #efefef;
}
.expanded .multi-choice .multiselect__content-wrapper .multiselect__option {
  background-color: #dfdfdf;
  width: 100%;
  padding: 20px;
  display: table;
  opacity: 0.5;
  border-bottom: 1px solid #efefef;
}
.expanded .multi-choice .multiselect__content-wrapper .multiselect__option.multiselect__option--selected {
  background-color: transparent !important;
  opacity: 1;
}
.expanded .multi-choice .multiselect__content-wrapper .multiselect__option:after {
  display: none;
}
.expanded .multi-choice .multiselect__content-wrapper .multiselect__option i {
  font-size: 2em;
  vertical-align: inherit;
}
.expanded .multi-choice .multiselect__content-wrapper .multiselect__option i:before {
  display: table-cell;
  width: 50px;
}
.expanded .multi-choice .multiselect__content-wrapper .multiselect__option span {
  font-size: 1.4em !important;
}
.multi-choice .multiselect__tags {
  height: auto !important;
}
.doublelist {
  .api-domain {
    width: 50%;
    padding: 0 15px 0 3px;
  }
}
</style>
